module.exports = __webpack_public_path__ + "img/vestel-venus-v3.541f4989.png";